import { Button, notification } from "antd";
import React, { useState } from "react";
import DataProvider from "../../services";
import PasswordInput from "../form/password-input";
import { useNavigate } from "react-router-dom";

export default function ResetPassword2(props: any) {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  // api["success"]({
  //   message: "Success",
  //   description:
  //     "Your password has been update successfully. Kindly sign in to your account.",
  //   btn: <Button type="primary">Sign in</Button>,
  //   onClick: () => navigate("/sign-in"),
  // });

  const handleChangePassword = async () => {
    if (password.length < 8) {
      return api["warning"]({
        message: "Password",
        description: "Password must be at least 8 characters.",
      });
    }
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecial = /[@$!%*?&]/.test(password);
    if (!hasUpperCase || !hasLowerCase || !hasNumber || !hasSpecial) {
      return api["warning"]({
        message: "Password",
        description:
          "Password must contain uppercase, lowercase, number and special character (@$!%*?&).",
      });
    }
    if (password !== confirmPassword) {
      return api["warning"]({
        message: "Password",
        description: "Passwords do not match.",
      });
    }
    const email = (props.email || "").trim().toLowerCase();
    if (!email) {
      return api["error"]({
        message: "Error",
        description: "Email is required. Please go back and verify your code again.",
      });
    }
    const payload = {
      email,
      token: String(props.otp || ""),
      newPassword: password,
    };
    setLoading(true);
    try {
      await DataProvider.resetPassword(payload);
      setLoading(false);
      return api["success"]({
        message: "Success",
        description:
          "Your password has been updated successfully. Kindly sign in to your account.",
        btn: <Button type="primary">Sign in</Button>,
        onClick: () => navigate("/sign-in"),
      });
    } catch (error: any) {
      setLoading(false);
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Sorry we couldn't update your password. Try again later.";
      return api["error"]({
        message: "Failed",
        description: msg,
      });
    }
  };

  return (
    <div className="w-full md:h-[70vh] h-[50vh] flex flex-col justify-start items-start">
      {props.noBack ? null : (
        <Button onClick={() => props.setInnerTab(2)} className="my-2">
          Back
        </Button>
      )}
      <div className="w-full my-2 flex flex-col justify-center items-center p-4">
        <div className="md:w-[40%] w-full">
          <h3 className="font-semibold text-lg">Reset Password</h3>
          <p className="py-2">
            Please type in your new password below. Password must be 8 or more
            characters.
          </p>

          <PasswordInput
            title="New Password"
            required
            password={password}
            setPassword={setPassword}
            placeholder="*****************"
          />

          <PasswordInput
            title="Confirm Password"
            required
            password={confirmPassword}
            setPassword={setConfirmPassword}
            placeholder="*****************"
          />

          <Button type="primary" onClick={handleChangePassword}>
            {loading ? "Saving..." : "Change password"}
          </Button>
          {props.noBack ? (
            <Button onClick={() => props.setInnerTab(1)} className="mx-2">
              Go Back
            </Button>
          ) : null}
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
